import { createSelector } from 'reselect';
import Account from 'records/AssignedAccount';

const accountsSelector = state => {
  return state.account.get('data');
};

export const getFirstAccount = createSelector(
  accountsSelector,
  accounts => {
    if (accounts && accounts.size >= 1) {
      return accounts.get(0)
    } else {
      return new Account();
    }
  }
);
